// extracted by mini-css-extract-plugin
export var shipmentMethodCardButton = "_redotech-redo-customer-portal-app-src-create-return-review-components-shipment-method-cards-shipment-method-cards-shipment-method-card-button";